"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.overlay = exports.closeIconButton = exports.closeIcon = exports.popupBody = exports.rootContainer = void 0;

var _emotion = require("emotion");

var rootContainer =
/*#__PURE__*/
(0, _emotion.css)("display:flex;justify-content:center;align-items:center;");
exports.rootContainer = rootContainer;

var popupBody = function popupBody(_ref) {
  var show = _ref.show,
      animate = _ref.animate,
      theme = _ref.theme,
      top = _ref.top,
      left = _ref.left,
      hideArrow = _ref.hideArrow,
      arrowPlacement = _ref.arrowPlacement,
      arrowCoords = _ref.arrowCoords;
  return (
    /*#__PURE__*/
    (0, _emotion.css)("position:absolute;display:flex;align-items:center;justify-content:center;min-height:34px;border-radius:4px;background:", theme.color.black1, ";color:#fff;width:auto;max-width:270px;line-height:20px;padding:8px;text-align:center;font-size:12px;box-sizing:border-box;top:", top, "px;left:", left, "px;z-index:10001;", show ?
    /*#__PURE__*/
    (0, _emotion.css)("display:flex;") :
    /*#__PURE__*/
    (0, _emotion.css)("display:none;"), "\n\n  ", animate ?
    /*#__PURE__*/
    (0, _emotion.css)("transform:scale(1);opacity:1;") :
    /*#__PURE__*/
    (0, _emotion.css)("transform:scale(0);opacity:0;"), "\n  ", hideArrow ? '' :
    /*#__PURE__*/
    (0, _emotion.css)("::after{content:\" \";position:absolute;border-style:solid;border-width:5px;", arrowPlacement === 'bottom' ?
    /*#__PURE__*/
    (0, _emotion.css)("top:100%;left:", arrowCoords.left, ";margin-left:-5px;border-color:", theme.color.black1, " transparent transparent transparent;") : '', "\n      ", arrowPlacement === 'top' ?
    /*#__PURE__*/
    (0, _emotion.css)("bottom:100%;left:", arrowCoords.left, ";margin-left:-5px;border-color:transparent transparent ", theme.color.black1, " transparent;") : '', "\n      ", arrowPlacement === 'left' ?
    /*#__PURE__*/
    (0, _emotion.css)("top:", arrowCoords.top, ";right:100%;margin-top:-5px;border-color:transparent ", theme.color.black1, " transparent transparent;") : '', "\n      ", arrowPlacement === 'right' ?
    /*#__PURE__*/
    (0, _emotion.css)("top:", arrowCoords.top, ";left:100%;margin-top:-5px;border-color:transparent transparent transparent ", theme.color.black1, ";") : '', "}"))
  );
};

exports.popupBody = popupBody;
var closeIcon =
/*#__PURE__*/
(0, _emotion.css)("fill:#fff;color:#fff;position:relative;cursor:pointer;");
exports.closeIcon = closeIcon;
var closeIconButton =
/*#__PURE__*/
(0, _emotion.css)("right:10px;top:10px;position:absolute;");
exports.closeIconButton = closeIconButton;
var overlay =
/*#__PURE__*/
(0, _emotion.css)("position:absolute;top:0;left:0;width:100%;height:100%;z-index:10000;background:rgba(0,0,0,0.5);");
exports.overlay = overlay;